module.exports = __webpack_public_path__ + "img/LegalPluralism1500-1850.c6250152.png";